import type { Link } from '../types';
import type { JointDefinition } from './JointAngles';

export interface RawLandmark {
  x: number;
  y: number;
  score: number;
  /** MediaPipe's poseWorldLandmarks — meters, hip-centered, y-up.
   *  Absent for engines that don't expose a 3D prediction. */
  worldX?: number;
  worldY?: number;
  worldZ?: number;
  worldVisibility?: number;
}

export interface RawPose {
  landmarks: RawLandmark[];
}

export interface RawPoseResult {
  poses: RawPose[];
}

export interface SkeletonDefinition {
  nodeNames: readonly string[];
  links: readonly Link[];
  jointDefs: readonly JointDefinition[];
}

export type PoseSource = HTMLVideoElement | HTMLCanvasElement;

export interface PoseEngine {
  readonly id: string;
  readonly label: string;
  readonly skeleton: SkeletonDefinition;
  readonly supportsMultiPose: boolean;
  initialize(): Promise<void>;
  setNumPoses(n: number): Promise<void>;
  detectForVideo(source: PoseSource, timestamp: number): Promise<RawPoseResult> | RawPoseResult;
  dispose(): void;
}

export function sourceWidth(source: PoseSource): number {
  return 'videoWidth' in source ? source.videoWidth : source.width;
}

export function sourceHeight(source: PoseSource): number {
  return 'videoHeight' in source ? source.videoHeight : source.height;
}
